import lodash, { sortBy } from 'lodash'
import { useRecoilState } from 'recoil'

import { TOrderEntryProduct } from '../types'
import useOrderEntry from '../useOrderEntry'
import { useProductsContext } from './ProductsContext'
import { productsStateFamily } from './state'

type TProducts = {
  products: TOrderEntryProduct[]
  setProducts: (products: TOrderEntryProduct[]) => void
  productsId: string | undefined
}

const useProducts = (propId?: string): TProducts => {
  const { id, initialValues } = useOrderEntry()

  const productsContext = useProductsContext()

  const productsId = propId || lodash.get(productsContext, 'id')

  const [value, onChange] = useRecoilState<TOrderEntryProduct[]>(
    productsStateFamily(`${id}_${productsId}`),
  )

  const setProducts = (products: TOrderEntryProduct[]): void => {
    const sortedProducts = sortBy(products, (p) =>
      (
        initialValues.defaultSlaTypeId === -1
          ? p.slaType === initialValues.defaultSlaTypeName
          : p.slaTypeId === initialValues.defaultSlaTypeId
      )
        ? 0
        : 1,
    )
    onChange(sortedProducts)
  }

  return {
    products: value,
    setProducts,
    productsId,
  }
}

export default useProducts
